import { render, staticRenderFns } from "./AddDocument.vue?vue&type=template&id=1c00374f&scoped=true"
import script from "./AddDocument.vue?vue&type=script&lang=js"
export * from "./AddDocument.vue?vue&type=script&lang=js"
import style0 from "./AddDocument.vue?vue&type=style&index=0&id=1c00374f&prod&scoped=true&lang=scss"
import style1 from "./AddDocument.vue?vue&type=style&index=1&id=1c00374f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c00374f",
  null
  
)

export default component.exports